// extracted by mini-css-extract-plugin
export default {"tasks":"dP-z","task":"eP-z","svg":"fP-z","text":"gP-z"};